// extracted by mini-css-extract-plugin
module.exports = {"burger":"styles_burger__3jcLd","active":"styles_active__14kHp"};